import ProtoCommands from './ProtoCommands';

const updateAndOpenChatProto = async (id?: string) => {
  if (id) {
    ProtoCommands.setHumanUid(id);
  }

  ProtoCommands.open();
};

export default updateAndOpenChatProto;
